export default __webpack_public_path__ + "static/media/blackTick.2744ddee.svg";